console.log("script activite - surcharge projet UGA");
document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('[class*="activite__liste__creneaux__details__plus_"]');

  // Aucun bloc trouvé, on ne fait rien
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    const btn = wrapper.querySelector('button[onclick]');
    const match = wrapper.className.match(/activite__liste__creneaux__details__plus_(\d+)/);
    if (!btn || !match) return;

    const id = 'activite__liste__creneaux__details__plus_' + match[1];
    const target = document.getElementById(id);
    if (!target) return;

    // Enrichissement accessibilité sur le bouton existant
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);

    // Icône décorative
    const icon = btn.querySelector('.icon-fleche_menu');
    if (icon) icon.setAttribute('aria-hidden', 'true');

    // Texte plus explicite pour les lecteurs d'écran
    const creneauNom = wrapper.closest('.activite__liste__creneaux__details')
        ?.querySelector('.activite__liste__creneaux--nom')
        ?.textContent.trim();

    if (creneauNom) {
      const srLabel = document.createElement('span');
      srLabel.className = 'sr-only';
      srLabel.textContent = ' – ' + creneauNom;
      btn.appendChild(srLabel);
    }
  });
});

window.fo_activite_toggle_div = function (btn, id) {
  const target = document.getElementById(id);
  if (!target) return;

  const isHidden = target.style.display === 'none' || target.style.display === '';
  target.style.display = isHidden ? 'block' : 'none';
  btn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');

  const icon = btn.querySelector('.icon-fleche_menu');
  if (icon) icon.style.transform = isHidden ? 'rotate(90deg)' : '';
};